import { jssPreset, MuiThemeProvider } from '@material-ui/core/styles';
import { createGenerateClassName, StylesProvider } from '@material-ui/core/styles';
import MessageBar from '@pbl/pbl-react-widgets/lib/shared/components/message-bar/MessageBar';
import { create } from 'jss';
import React from 'react';
import ReactDOM from 'react-dom';
import getTheme from '../shared/theme/custom';
import jssVendorPrefixer from '../utils/jssVendorPrefix';

const jss = create({ plugins: [...jssPreset().plugins, jssVendorPrefixer()] });

interface IProp {
  selector: string;
  identifier?: string;
  skipStyles?: boolean;
}

const generateClassName = createGenerateClassName({
  productionPrefix: 'eWidget-',
  disableGlobal: true,
  seed: 'eWidget'
});

const WidgetRenderer: React.FC<IProp> = props => {
  const { selector, children } = props;
  const element = document.querySelector(selector);

  if (element == null) {
    return null;
  }

  element.classList.add(`po-widget-loader`);

  if (props.skipStyles) {
    return <>
      {children}
    </>;
  }

  const widget = (
    <StylesProvider jss={jss} generateClassName={generateClassName}>
      <MuiThemeProvider theme={getTheme()}>
        <MessageBar />
        {children}
      </MuiThemeProvider>
    </StylesProvider>
  );

  return ReactDOM.createPortal(widget, element);
};

export default WidgetRenderer;
